import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { NumberInputValue } from '@/js/libs/ui/src/V2';

import { NumberInput } from 'src/components/ui';

type NumberFilterProps = {
  filter: NumberInputValue;
  placeholder?: string;
  dataTestId?: string;
  onChange: (value: NumberInputValue) => void;
  width?: number;
};

export const NumberFilter = memo(function NumberFilter({
  filter,
  placeholder,
  dataTestId = 'number-filter',
  onChange,
  width,
}: NumberFilterProps) {
  const [t] = useTranslation(['common']);

  return (
    <NumberInput value={filter} onChange={onChange} placeholder={placeholder ?? t('common:ENTER')} dataTestId={dataTestId} width={width} />
  );
});
